export const GET_TAG = 'REQUIREMENT/get_tag';
export const REMOVE_TAG = 'REQUIREMENT/remove_tag';
export const GET_REQUIREMENT_ITEM = 'REQUIREMENT/GET_REQUIREMENT_ITEM';

export const GET_REQUIREMENT_LIST = 'REQUIREMENT/GET_REQUIREMENT_LIST';
export const GET_PERMIT_TYPE_LIST = 'REQUIREMENT/GET_PERMIT_TYPE_LIST';
export const GET_BUSINESS_LINE_LIST = 'REQUIREMENT/GET_BUSINESS_LINE_LIST';
export const UPDATE_BUSINESS_LINE_REQUIREMENT = 'REQUIREMENT/UPDATE_BUSINESS_LINE_REQUIREMENT';
export const UPDATE_APPLICATION_REQUIREMENT = 'REQUIREMENT/UPDATE_APPLICATION_REQUIREMENT';
export const GET_BUSINESS_LINES_LIST = `REQUIREMENT/GET_BUSINESS_LINES_LIST`;
export const GET_BUSINESS_LINE = `REQUIREMENT/GET_BUSINESS_LINE`;
export const GET_REPORT_ACCESS = 'REQUIREMENT/get_report_access';